import { bankOptions } from 'store/utils';
import {
  companyLegalTypeList,
  validateEmail,
  validateEmailNotMandatory,
  validatePhoneNumber,
  validateWebSite,
} from 'utils';

export const formFields2_1 = (isIbanDisabled, isBnkNameDisabled) => [
  {
    id: 'companyName',
    label: 'Δήμος',
    type: 'text',
    name: 'companyName',
    size: 'large',
    placeholder: 'Εισάγετε Δήμο',
    span: 24,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    disabled: true,
    asterisk: true,
  },
  {
    id: 'abiVat',
    label: 'Α.Φ.Μ. Δήμου',
    type: 'text',
    name: 'abiVat',
    size: 'large',
    placeholder: 'Εισάγετε Α.Φ.Μ. Δήμου',
    span: 24,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      /*() => ({
          validator(_, value) {
            return validateAFM(value);
          },
        }),*/
    ],
    disabled: true,
  },
  {
    id: 'iban',
    label: 'IBAN',
    type: 'text',
    name: 'iban',
    size: 'large',
    placeholder: 'Εισάγετε IBAN',
    span: 24,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      {
        pattern: /^GR\d{25}$/,
        message: 'Παρακαλώ εισάγετε έγκυρο ελληνικό IBAN',
        transform: value =>
          value ? value.replace(/\s+/g, '').toUpperCase() : value,
      },
      /*() => ({
         validator(_, value) {
           return validateAFM(value);
         },
       }),*/
    ],
    disabled: isIbanDisabled,
  },
  {
    id: 'bnkName',
    label: 'Πιστωτικό Ίδρυμα',
    type: 'select',
    name: 'bnkName',
    size: 'large',
    placeholder: 'Εισάγετε Πιστωτικό Ίδρυμα',
    span: 24,
    asterisk: true,
    options: bankOptions,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
    disabled: isBnkNameDisabled,
  },
  //   {
  //     id: 'regDate',
  //     label: 'Ημ. Σύστασης',
  //     type: 'text',
  //     name: 'regDate',
  //     size: 'large',
  //     placeholder: 'Εισάγετε Ημ. Σύστασης',
  //     span: 24,
  //     rules: [
  //       { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
  //       { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
  //     ],
  //     asterisk: true,
  //     disabled: true,
  // },
  // {
  //   id: 'companyLegalType',
  //   label: 'Νομική Μορφή',
  //   title: 'Νομική Μορφή',
  //   type: 'text',
  //   name: 'companyLegalType',
  //   size: 'medium',
  //   //options: companyLegalTypeList,
  //   placeholder: 'Επιλέξτε Νομική Μορφή',
  //   span: 24,
  //   asterisk: true,
  //   rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  // },
  // {
  //   id: 'companySize',
  //   label: 'Μέγεθος Επιχείρησης σύμφωνα με ΥΔ ΜΜΕ',
  //   type: 'radio',
  //   name: 'companySize',
  //   size: 44,
  //   options: [
  //     { label: 'Μικρή', value: 'Μικρή' },
  //     { label: 'Μεσαία', value: 'Μεσαία' },
  //     { label: 'Μεγάλη', value: 'Μεγάλη' },
  //   ],
  //   placeholder: '-',
  //   span: 24,
  //   asterisk: true,
  //   infoMessage:
  //   <span className='iban-info-title'> <b>Μικρή Επιχείρηση: </b> Λιγότεροι από 50 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών και/ή Ισολογισμός {'<='} 10.000.000,00€<br/>
  //   <b>Μεσαία Επιχείρηση: </b> Λιγότεροι από 250 Εργαζόμενοι και Ετήσιος Κύκλος Εργασιών {'<='}50.000.000,00€ και/ή Ετήσιος Ισολογισμός {'<='} 43.000.000,00€<br/>
  //   <b>Μεγάλη Επιχείρηση:</b> Περισσότεροι από 250 Εργαζόμενοι ή Ετήσιος Κύκλος Εργασιών {'>'} 50.000.000€ και Ετήσιος Ισολογισμός {'>'} 43.000.000,00€<br/></span>,
  //   infoMessageClassName: 'multiline-info-message',
  //   iconClassName: 'mt-1',
  //   rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  // },
];

export const formFields2_2 = [
  {
    id: 'abiStreetFull',
    label: 'Οδός - Αριθμός',
    type: 'text',
    name: 'abiStreetFull',
    size: 'large',
    placeholder: 'Εισάγετε Οδό - Αριθμό',
    span: 12,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    disabled: true,
  },
  {
    id: 'abiTk',
    label: 'Τ.Κ.',
    type: 'select',
    name: 'abiTk',
    size: 'small',
    placeholder: 'Εισάγετε Τ.Κ.',
    span: 12,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    // disabled: false,
  },
  {
    id: 'abiPerfecture',
    label: 'Νομός',
    title: 'Νομός',
    type: 'select',
    name: 'abiPerfecture',
    size: 'small',
    placeholder: 'Επιλέξτε Νομό',
    span: 12,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    //disabled: true,
  },
  {
    id: 'abiDistrict',
    label: 'Περιοχή',
    title: 'Περιοχή',
    type: 'select',
    name: 'abiDistrict',
    size: 'small',
    placeholder: 'Επιλέξτε Περιοχή',
    span: 12,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    //disabled: true,
  },
  {
    id: 'invMob',
    label: 'Τηλέφωνο',
    type: 'text',
    name: 'invMob',
    size: 'large',
    maxLength: 10,
    placeholder: 'Εισάγετε Τηλέφωνο',
    span: 24,
    rules: [
      () => ({
        validator(_, value) {
          return validatePhoneNumber(value, false, false);
        },
      }),
    ],
  },
  {
    id: 'website',
    label: 'Ιστοχώρος',
    // prefix: 'http://',
    type: 'text',
    name: 'website',
    size: 'large',
    placeholder: 'Εισάγετε Ιστοχώρο',
    maxLength: 80,
    span: 24,
    rules: [
      {
        validator: validateWebSite,
      },
    ],
  },
  {
    id: 'invMail',
    label: 'E-mail',
    type: 'text',
    name: 'invMail',
    size: 'large',
    placeholder: 'Εισάγετε E-mail',
    maxLength: 50,
    span: 24,
    asterisk: true,
    rules: [
      () => ({
        validator(_, value) {
          return validateEmail(value);
        },
      }),
    ],
  },
];
